export default "__VITE_ASSET__da896001__"